import Vue from 'vue'
import DateRangePicker from 'vue2-daterange-picker'

const CustomDateRangePicker = {
  extends : DateRangePicker,
  methods : {
    togglePicker (open) {
      DateRangePicker.methods.togglePicker.call(this, open)
      
      if (!open) {
        return
      }

      this.$nextTick(() => {
        const cancelBtn = this.$el.querySelector('.cancelBtn')
        
        if (cancelBtn) {
          cancelBtn.classList.remove('btn-default')
          cancelBtn.classList.add('btn-primary', 'bordered')
        }
      })
    }
  }
}

Vue.component('DateRangePicker', CustomDateRangePicker)
